/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryBasicEntryRequest
 */
export interface RevisdomAPIViewModelsEntryBasicEntryRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryBasicEntryRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryBasicEntryRequest
     */
    entryType?: RevisdomAPIViewModelsEntryBasicEntryRequestEntryTypeEnum;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryBasicEntryRequestEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryBasicEntryRequestEntryTypeEnum = typeof RevisdomAPIViewModelsEntryBasicEntryRequestEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryBasicEntryRequestEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryBasicEntryRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryBasicEntryRequest(value: object): value is RevisdomAPIViewModelsEntryBasicEntryRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryBasicEntryRequestFromJSON(json: any): RevisdomAPIViewModelsEntryBasicEntryRequest {
    return RevisdomAPIViewModelsEntryBasicEntryRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryBasicEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryBasicEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
    };
}

export function RevisdomAPIViewModelsEntryBasicEntryRequestToJSON(json: any): RevisdomAPIViewModelsEntryBasicEntryRequest {
    return RevisdomAPIViewModelsEntryBasicEntryRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryBasicEntryRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryBasicEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entryType': value['entryType'],
    };
}

